import axios from "axios";
import Constants from "../../../components.constants.js";

export default {

    async getPluginsRepoFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.pluginRepoUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getPluginsRepoFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getInstalledPluginsFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.pluginRepoInstalledUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getInstalledPluginsFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async installPlugin(context, payload = {}) {

        try {
            let resp = await axios.post(Constants.pluginsUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[installPlugin][Store][Bin add resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[installPlugin][Store][Error occured while adding bin--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }

    },

    async uninstallExistingPlugin(context, payload = {}) {
        try {
          let resp = await axios.put(`${Constants.pluginsUrl}/${payload.plugin_id}`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[uninstallExistingPlugin][Store][Plugin uninstall resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[uninstallExistingPlugin][Store][Error occured while uninstalling Tag--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
    
      },
      async upgradeExistingPlugin(context, payload = {}) {
        try {
          let resp = await axios.put(`${Constants.pluginsUrl}/${payload.plugin_id}`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[upgradeExistingPlugin][Store][Plugin upgrade resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[upgradeExistingPlugin][Store][Error occured while upgrading Tag--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
    
      }
};